import { OptionPriceBasic } from '../../lib/types/models/option-prices/option-price'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getOptionProductDatePrice(input: { optionId: number; productDateId: number }) {
  const { optionId, productDateId } = input
  return restApiClient
    .url(
      constructApiUrl(API.options.getProductDatePrice.url, { id: optionId, dateId: productDateId })
    )
    .get<OptionPriceBasic>()
}
